// extracted by mini-css-extract-plugin
export var readonly = "_j6-1";
export var star = "_j6-0";